import {
  pixelViewContent,
  pixelAddToCart,
  pixelInitiateCheckout,
  pixelPurchase,
  pixelLead,
  pixelPageView,
} from "./metaPixel";

const GA_ID = process.env.REACT_APP_GA_ID;

function gtag(...args) {
  if (window.gtag) window.gtag(...args);
}

export function trackPageView(path) {
  gtag("config", GA_ID, { page_path: path });
  // React Router doesn't trigger a hard navigation, so Meta's bootstrap
  // PageView (in index.html) only fires once. Fire one per SPA route change
  // so PageView / ViewContent / etc all keep counting in Events Manager.
  pixelPageView();
}

export function trackEvent(name, params = {}) {
  gtag("event", name, params);
}

export function trackAddToCart(product, size) {
  gtag("event", "add_to_cart", {
    currency: "RSD",
    value: product.salePrice || product.price,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.salePrice || product.price,
        quantity: 1,
        item_variant: size || undefined,
      },
    ],
  });
  pixelAddToCart(product, size, 1);
}

export function trackViewItem(product) {
  gtag("event", "view_item", {
    currency: "RSD",
    value: product.salePrice || product.price,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.salePrice || product.price,
      },
    ],
  });
  pixelViewContent(product);
}

export function trackInitiateCheckout({ items, total }) {
  gtag("event", "begin_checkout", {
    currency: "RSD",
    value: total,
    items: (items || []).map((i) => ({
      item_id: i.id || i.productId,
      item_name: i.name,
      item_variant: i.size || undefined,
      quantity: i.quantity,
      price: i.price,
    })),
  });
  pixelInitiateCheckout({ items, total });
}

export function trackPurchase(order) {
  gtag("event", "purchase", {
    transaction_id: order.orderNumber,
    value: order.total,
    currency: "RSD",
    items: (order.items || []).map((item) => ({
      item_name: item.name,
      item_variant: item.size || undefined,
      quantity: item.quantity,
      price: item.price,
    })),
  });
  pixelPurchase(order);
}

export function trackNewsletterSignup({ email, name, source } = {}) {
  gtag("event", "newsletter_signup");
  return pixelLead({ email, name, source });
}
